import { createTheme } from '@material-ui/core/styles';

export const vaisandTheme = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: '#001F66',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#1959D9',
            contrastText: '#FFFFFF',
        },
        error: {
            main: '#FF400D',
        },
        tertiary: {
            main: '#FF400D',
            contrastText: '#FFFFFF',
        },
        divider: '#0D2550',
    },
});
